import { createFileRoute } from '@tanstack/react-router';

import { usePartnerId } from '../../features/inbox/use-partner-name';
import { OperationsChecksMatrix } from '../../features/operations/operations-checks-matrix';
import { OperationsIndexStepper } from '../../features/operations/operations-index-stepper';

export const Route = createFileRoute('/operations/checks')({
  staticData: { breadcrumb: 'Checks', layout: 'full-height' },
  component: OperationsChecksPage,
});

function OperationsChecksPage() {
  const partnerId = usePartnerId();
  return (
    <div className="flex h-full min-h-0 flex-col">
      <OperationsIndexStepper />
      {partnerId && <OperationsChecksMatrix key={partnerId} partnerId={partnerId} />}
    </div>
  );
}
